import { PhaserConfig, SceneConfig, getDefaultConfigPhaser } from '../components/Phaser/types/config';
import { TSprite } from '../models/objects/sprite';
import { TObstacle, TScene } from '../models/objects/objects';
import { getImagePath } from './format/valueFormat';

export const mapImportedPhaserConfig = (
    config: PhaserConfig,
    sprites: TSprite[],
    obstacles: TObstacle[],
    scenes: TScene[] = [],
): PhaserConfig => {
    const phaser = config ?? getDefaultConfigPhaser();

    const scene: SceneConfig = (() => {
        const baseScene = phaser.scene ?? getDefaultConfigPhaser().scene;
        const sceneId = baseScene.id?.replace(/^scene_/, '') || '';
        const sceneDb = scenes.find(
            (sc) => sc.name === baseScene.id || String(sc.id) === sceneId,
        );

        return {
            ...baseScene,
            id: baseScene.id || (sceneDb ? `scene_${sceneDb.id}` : ''),
            background: {
                image: baseScene.background?.image || getImagePath(sceneDb?.img || ''),
                mode: baseScene.background?.mode || 'cover',
            },
        };
    })();

    const characters = (phaser.characters || []).map((c) => {
        const sprite = sprites.find(
            (s) =>
                s.name === c.name ||
                String(s.id) === c.id ||
                s.name === c.idPhaser ||
                String(s.id) === c.idPhaser,
        );
        return {
            ...c,
            id:
                c.id ||
                (typeof crypto !== 'undefined' && (crypto as any).randomUUID
                    ? (crypto as any).randomUUID()
                    : `char_${Date.now()}_${Math.floor(Math.random() * 1e6)}`),
            idPhaser: c.idPhaser || sprite?.name || '',
            name: c.name || sprite?.name || '',
            image_url: getImagePath(c.image_url || sprite?.image_url || ''),
            animations:
                c.animations && c.animations.length > 0
                    ? c.animations
                    : sprite?.animations || [],
        };
    });
    const objects = (phaser.objects || []).map((o) => {
        const obstacle = obstacles.find((ob) => ob.name === o.name || String(ob.id) === o.id);
        
        // If object has pickOrder > 0, it should be pickable and movable by default
        const hasPickOrder = o.pickOrder && Number(o.pickOrder) > 0;
        
        return {
            immovable: hasPickOrder ? false : true,
            pickable: hasPickOrder ? true : false,
            pushable: false,
            decor: false,
            ...o,
            assets: {
                texture: obstacle ? getImagePath(obstacle.img) : o.assets?.texture || '',
            },
        };
    });

    const sounds = (phaser.sounds || []).map((s) => ({
        volume: 1,
        loop: false,
        ...s,
    }));

    return {
        ...getDefaultConfigPhaser(),
        ...phaser,
        scene,
        characters,
        objects,
        sounds,
    };
};